import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-edit-buttonfrom-grid',
  template: `
  <em disabled="enableEdit && !lpFlag" [ngStyle]="{'cursor': !enableEdit || lpFlag ? 'not-allowed' : 'pointer' }">
    <img src="./assets/images/edit_blue.svg" style="height: 18px;width: 18px;" *ngIf="!lpFlag || routePCB" (click)="btnClickedHandler('edit', false)">
    <img src="./assets/images/delete_red.svg" style="height: 18px;width: 18px;" *ngIf="!lpFlag && !routePCB " (click)="btnClickedHandler('delete', false)">
    <img src="./assets/images/edit_blue.svg" style="height: 18px;width: 18px;" *ngIf="lpFlag" (click)="btnClickedHandler('edit', true)">
   </em>
  `,
  styles: [
  ]
})
export class EditButtonfromGridComponent implements ICellRendererAngularComp, OnDestroy {
  params: any
  enableEdit: boolean = true;
  enableDelete: boolean = true;
  pageName!: string;
  lpFlag: boolean = false;
  routePCB: boolean = false;
  disableWaitlane_Route: boolean = false
  constructor() { }
  agInit(params: any): void {
    this.params = params;
    this.pageName = this.params.colDef.field;
    console.log(this.pageName, "this.pageName", this.params.disableFromWaitlane)
    this.lpFlag = this.params.lpFlag;
    this.disableWaitlane_Route = this.params.disableFromWaitlane
    //tier
    if (this.params.data.hasOwnProperty("enableDelete") && !this.params.data['enableDelete']) {
      this.enableDelete = false;
    }
    if (this.params.data.hasOwnProperty("enableEdit") && !this.params.data['enableEdit']) {
      this.enableEdit = false;
    }
    if (this.pageName == "compliance-management") {
      this.enableEdit = true;
      this.enableDelete = false;
    }
    if (this.pageName == "routePCB") {
      this.routePCB = true
    }

    if (this.disableWaitlane_Route) {
      this.enableEdit = false;
      this.enableDelete = false;
    }
    console.log(this.enableDelete, this.enableEdit, (this.enableEdit && !this.lpFlag))
  }
  refresh(params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
  ngOnDestroy() {
  }

  ngOnInit(): void {
  }

  btnClickedHandler(action: any, lpFlag: any) {

    if (action == 'edit' && lpFlag == false) {
      if (this.enableEdit)
        this.params.context.componentParent.editTemplateRow(this.params.data);
    }
    if (action == 'edit' && lpFlag == true) {
      if (this.enableEdit)
        this.params.context.componentParent.editLp(this.params.data);
    }
    if (action == "delete" && lpFlag == false) {
      if (this.enableDelete)
        this.params.context.componentParent.deleteAdditionallane(this.params.data);
    }
  }

}
